import React from "react";
import "./404.css";
import { useTranslation } from "../../../Hooks/useTranslation";

const Error404 = () => {
  const { t } = useTranslation();
  return (
    <div className="error-page">
      <div className="error-card">
        <h1 className="error-title">404</h1>
        <p className="error-subtitle">{t.notFound.subtitle}</p>
        <a href="/" className="back-home">{t.notFound.back}</a>
      </div>
    </div>
  );
};

export default Error404;
